import { render } from "./ScoreGradientCircle.vue?vue&type=template&id=197d4cb1&scoped=true&ts=true"
import script from "./ScoreGradientCircle.ts?vue&type=script&lang=ts&external"
export * from "./ScoreGradientCircle.ts?vue&type=script&lang=ts&external"

import "./ScoreGradientCircle.scss?vue&type=style&index=0&id=197d4cb1&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197d4cb1"]])

export default __exports__